<template>
    <div>
        <no-internet-explorer v-if="showIEMessage" @close="closeIEMessage"></no-internet-explorer>
        <vue-progress-bar></vue-progress-bar>
        <richPrompt v-if="getShowRichPrompt"></richPrompt>
        <upgrade-plan-popup></upgrade-plan-popup>
        <something-went-wrong-popup></something-went-wrong-popup>
        <full-screen-loader :active="getFullScreenLoading"></full-screen-loader>
        <div class="app" :class="{blurry: getFullScreenLoading}">
            <notifications position="bottom right" group="notifications" />
            <component :is="layout"></component>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Teaser from './components/layouts/Teaser'
    import Auth from './components/layouts/Auth'
    import Error from './components/layouts/Error'
    import Basic from './components/layouts/Basic'
    import Pluralo from './components/layouts/Pluralo'
    import Loading from './components/layouts/Loading'
    import FullScreenLoader from './tools/fullScreenLoader/FullScreenLoader'
    import UpgradePlanPopup from './components/other/UpgradePlanPopup'
    import SomethingWentWrongPopup from './components/other/SomethingWentWrong'
    import RichPrompt from '@/tools/richPrompt/richPrompt'
    import NoInternetExplorer from './components/other/noInternetExplorer'

    export default {
        data: function () {
            return {
                showIEMessage: false,
            }
        },
        created: function() {
            let vm = this

            // if client is Internet Explorer (shame on them) display a friendly message
            this.setIEMessageVisibility()

            // Download global stuff that not requires auth
            this.init();

            // Check if user is Supplier and is loggedin or not, or if it is agent
            this.checkUser({
                route: this.$route
            }).then(response => {
                console.log('this user is :' + response);
                if(response != 'agent'){
                    vm.switchLayout(this.stripLayoutNameFromRoutePrefix(this.$route.name));
                }
            })
        },
        computed: {
            ...mapGetters([
                'layout',
                'account',
                'getFullScreenLoading',
                'getShowRichPrompt'
            ])
        },
        methods: {
            ...mapActions([
                'refreshAccountData',
                'switchLayout',
                'initGeography',
                'initCompany',
                'initApp',
                'downloadSlimFilters',
                'startFullScreenLoading',
                'initAuthed',
                'downloadSalesChannels',
                'checkUser'
            ]),
            setIEMessageVisibility: function () {
                var ua = window.navigator.userAgent;

                var msie = ua.indexOf('MSIE ');
                if (msie > 0) {
                    // IE 10 or older => return version number
                    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                }

                var trident = ua.indexOf('Trident/');
                if (trident > 0) {
                    // IE 11 => return version number
                    this.showIEMessage = true
                    var rv = ua.indexOf('rv:');
                    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                }

                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                   // Edge (IE 12+) => return version number
                   return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                }

                // other browser
                return false;
            },
            stripLayoutNameFromRoutePrefix: function(route) {
                return route ? route.substring(0, route.indexOf('.')) : '';
            },
            async init() {
                this.initGeography().then((response) => {
                    // If we refresh the page, vue-router hasn't been triggered yet.
                    // We need to make sure our layout is set correctly; afterwards
                    // any layout changes will be handled by watching vue-router.
                    // We can tell which layout to use by parsing the route's name prefix,
                    // e.g. auth.login will use the layout 'auth'.
                    // If there's no specified prefix, the layout 'pluralo' will be used.
                    // console.log('initGeography promisse done', response);

                    // this.switchLayout(this.stripLayoutNameFromRoutePrefix(this.$route.name));
                });
            },
            closeIEMessage: function () {
                this.showIEMessage = false
            }
        },
        components: {
            Teaser,
            Pluralo,
            Auth,
            Error,
            Basic,
            FullScreenLoader,
            Loading,
            UpgradePlanPopup,
            SomethingWentWrongPopup,
            RichPrompt,
            NoInternetExplorer
        },
        watch: {
            '$route' (to, from) {
                this.switchLayout(this.stripLayoutNameFromRoutePrefix(to.name));
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '/assets/scss/_variables.scss';
.app{
    background: $background;
    transition: all ease-in-out 200px;
    &.blurry{
        filter:blur(5px);
    }
}
</style>



// WEBPACK FOOTER //
// App.vue?3fa099b6